import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const decodeJwtPayload = (token) => {
    if (!token) return null;
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    try {
        const payload = parts[1]
            .replace(/-/g, '+')
            .replace(/_/g, '/');
        const json = decodeURIComponent(atob(payload).split('').map((c) => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(json);
    } catch (err) {
        return null;
    }
};

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('adminToken');
    let adminUser = null;
    try {
        adminUser = JSON.parse(localStorage.getItem('adminUser'));
    } catch (error) {
        adminUser = null;
    }

    const payload = token && token !== 'null' && token !== 'undefined' ? decodeJwtPayload(token) : null;
    const isValidAdmin = token && adminUser && payload && (payload.isAdmin || payload.username);

    if (!isValidAdmin) {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminUser');
        return <Navigate to="/admin/login" replace />;
    }

    return children ? children : <Outlet />;
};

export default ProtectedRoute;
